<body>
    <div class="grid-overlay">
        <app-page-header>
            <button class="header-action-btn" (click)="goBack()">{{ 'portal.back' | translate }}</button>
        </app-page-header>
        <div class="create-portal">
            <div class="second-headboard">
                <h1>{{ 'portal.title' | translate }}</h1>
                <!-- <img src="../../../assets/icons/2341.png" alt="logo de Billcentrix"> -->
                <div class="linked-icons" >
                    <button class="active" >{{ 'portal.steps.template' | translate }}</button>
                    <button   (click)="goToFeatures()">{{ 'portal.steps.customization' | translate }}</button>
                    <button>{{ 'portal.steps.activate' | translate }}</button>
                    <!-- <img src="../../assets/icons/1_cuenta_off.png" alt="Paso 1: Cuenta" (click)="goBack()" >
                    <img src="../../assets/icons/2_portales_on.png" alt="Paso 2: Portal" >
                    <img src="../../assets/icons/3_personalizar_off.png" alt="Paso 3: Personalizar" (click)="goToFeatures()">
                    <img src="../../assets/icons/4_planes_off.png" alt="Paso 4: Planes" (click)="goToPlans()"> -->
                </div>
            </div>
            <div class="portal-info">
                <h1>{{ 'portal.selectTheme' | translate }}</h1>
                <p>{{ 'portal.canChangeColors' | translate }}</p>
                <div class="grid">
                    <div class="essential template-item" [class.selected]="checked === 3" (click)="selectTemplate(3)">
                        <h1>{{ 'portal.templates.basic.title' | translate }}</h1>
                        <p>{{ 'portal.templates.basic.description' | translate }} </p>
                        <img src="../../../assets/images/portal-basico.png" alt="vista previa del portal basico">
                        <div class="preview">
                            <div class="preview-text">
                                <a  [routerLink]="'/basic'" target="_blank"><img src="../../../assets/icons/ver.png" alt="vista previa"></a>
                                <!-- <p class="text-right">Vista previa</p> -->
                            </div>
                            <div class="round-checkbox">
                                <input type="checkbox" id="checkboxBasic"  name="checkboxBasic"
                                (click)="selectTemplate($event)" [checked]="checkboxBasicValue" [value]="3"
                                [(ngModel)]="checkboxBasicValue" (change)="handleCheckboxChange('basic')">
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="practical template-item" [class.selected]="checked === 2" (click)="selectTemplate(2)" >
                            <h1>{{ 'portal.templates.practical.title' | translate }}</h1>
                            <p>{{ 'portal.templates.practical.description' | translate }}</p>
                            
                            <img src="../../../assets/images/portal-practico.png" alt="vista previa del portal practico">
                            <div class="preview">
                                <div class="preview-text">
                                   <a [routerLink]="'/practic'" target="_blank"> <img  src="../../../assets/icons/ver.png" alt="vista previa"></a>
                                    <!-- <p class="text-right">Vista previa</p> -->
                                </div>
                                <div class="round-checkbox">
                                    <input type="checkbox" id="checkboxPractical" name="checkboxPractical" 
                                    (click)="selectTemplate($event)"  [checked]="checkboxPracticalValue"  [value]="2"
                                    [(ngModel)]="checkboxPracticalValue" (change)="handleCheckboxChange('practical')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="contemporary template-item" [class.selected]="checked === 1" (click)="selectTemplate(1)">
                        <h1>{{ 'portal.templates.contempo.title' | translate }}</h1>
                        <p>{{ 'portal.templates.contempo.description' | translate }}</p>
                        <img src="../../../assets/images/portal-contempo.png" alt="vista previa del portal contempo">
                        <div class="preview">
                            <div class="preview-text">
                               <a [routerLink]="'/contempo'" target="_blank" > <img src="../../../assets/icons/ver.png" alt="vista previa"></a>
                                <!-- <p class="text-right">Vista previa</p> -->
                            </div>
                            <div class="round-checkbox">
                                <input type="checkbox" id="checkboxContempo" name="checkboxContempo" 
                                (click)="selectTemplate($event)"  [checked]="checkboxContempoValue" [value]="1"
                                [(ngModel)]="checkboxContempoValue" (change)="handleCheckboxChange('contempo')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="options-buttons">
            <button (click)="goBack()" class="back-btn">{{ 'accountSettings.back' | translate }}</button>
            <button class="continue-btn" (click)="saveTemplate()"*ngIf="exist" >{{ 'portal.saveAndContinue' | translate }}</button>
            <button class="continue-btn" (click)="saveTemplate()"  *ngIf="!exist">{{ 'accountSettings.continue' | translate }}</button>
        </div>
    </div>
</body>